import { PreviewPrintOrderRequest, RenderPrintOrderRequest } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { openHtmlInNewTab } from '@bringg-frontend/utils';

type HtmlSanitizer = (html: string) => string;

const printReceipt = async (payload: RenderPrintOrderRequest, sanitize: HtmlSanitizer): Promise<void> => {
	const html = await getRootEnv().dashboardSdk.sdk.templatesApi.receipt(payload);
	openHtmlInNewTab(sanitize(html));
};

const printPreview = async (payload: PreviewPrintOrderRequest, sanitize: HtmlSanitizer): Promise<void> => {
	const html = await getRootEnv().dashboardSdk.sdk.templatesApi.preview(payload);
	openHtmlInNewTab(sanitize(html));
};

export const orderReceiptPrintingProvider = {
	printReceipt,
	printPreview
};
